import React, { useState } from "react"
import styled from "styled-components"
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextareaAutosize,
  IconButton,
  TextField,
  FormHelperText,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
} from "@material-ui/core"
import AttachFileIcon from "@material-ui/icons/AttachFile"
import DeleteIcon from "@material-ui/icons/Delete"
import commonStyles from "../../../styles/Pages/common/styles"
import { CloseIcon } from "@iconsGallery"
const CommentsDialog = (props) => {
  const classes = commonStyles()
  const {
    isComments = false,
    setIsComments = () => {},
    commentsClickHandler = () => {},
    handleCommentsDialogClose = () => {},
    setIsActionComments = () => {},
    setCommentsOpen = () => {},
    getCommentsReason = "",
    setCommentsReason = () => {},
    propsName = () => {},
    acknowledgedComment = "",
    resolvedComment = "",
  } = props

  return (
    <Dialog
      open={isComments}
      onClose={handleCommentsDialogClose}
      aria-labelledby="draggable-dialog-title"
      style={{ width: "410px", marginLeft: "auto", marginRight: "auto" }}
    >
      <Grid container direction="row" style={{ width: "100%", padding: 20 }}>
        <IconButton
          style={{ position: "absolute", top: 10, right: 10 }}
          onClick={handleCommentsDialogClose}
        >
          <CloseIcon />
        </IconButton>
        <Grid container direction="row" style={{ marginTop: 10 }}>
          <Typography
            variant="h5"
            style={{
              marginTop: "2px",
              marginLeft: "4px",
              fontWeight: "600",
            }}
          >
            {`Acknowledged Comments`}
          </Typography>
          <Grid item container xs={12} style={{ paddingTop: "10px" }}>
            <TextField
              type="text"
              variant="outlined"
              name="TaxFailureReason"
              placeholder="No Comments Available"
              multiline
              rows={6}
              value={acknowledgedComment}
              style={{
                width: "100%",
                height: "fit-content",
                backgroundColor: "#f6f6f6",
                borderRadius: "10px",
                minHeight: 100,
              }}
              disabled={true}
              inputProps={{ readOnly: true }}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" style={{ marginTop: 10 }}>
          <Typography
            variant="h5"
            style={{
              marginTop: "2px",
              marginLeft: "4px",
              fontWeight: "600",
            }}
          >
            {`Resolved Comments`}
          </Typography>
          <Grid item container xs={12} style={{ paddingTop: "10px" }}>
            <TextField
              disabled={true}
              type="text"
              variant="outlined"
              name="TaxFailureReason"
              placeholder="No Comments Avilable"
              multiline
              rows={6}
              value={resolvedComment}
              inputProps={{ readOnly: true }}
              style={{
                width: "100%",
                height: "fit-content",
                borderRadius: "10px",
                backgroundColor: "#f6f6f6",
                minHeight: 100,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export { CommentsDialog }
export default CommentsDialog
